import type { ReactNode } from 'react';
import { FilterX } from 'lucide-react';
import { cn } from '@/lib/cn';
import { formatNumber } from '@/lib/format';
import { Button } from './button';
import { SearchBox } from './search';

/**
 * The row above every list: search first, then the filters, then — pushed
 * right — what the filters left of the whole, a reset when any is active,
 * and the list's actions (export, create).
 */
export function TableToolbar({ search, children, shown, total, onReset, actions, className }: {
  search?: { value: string; onChange: (v: string) => void; placeholder: string };
  children?: ReactNode;
  shown?: number;
  total?: number;
  /** Present and non-null when at least one filter is active. */
  onReset?: (() => void) | null;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('mb-4 flex flex-wrap items-center gap-2', className)}>
      {search && <SearchBox value={search.value} onChange={search.onChange} placeholder={search.placeholder} className="w-full sm:w-64" />}
      {children}
      <div className="ml-auto flex items-center gap-2">
        {shown !== undefined && total !== undefined && shown !== total && (
          <span className="text-xs text-muted tabular-nums">{formatNumber(shown)} из {formatNumber(total)}</span>
        )}
        {onReset && <Button size="sm" variant="ghost" icon={<FilterX size={13} />} onClick={onReset}>Сбросить</Button>}
        {actions}
      </div>
    </div>
  );
}
